var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mb-3"},[(_vm.loading)?_c('b-spinner',{attrs:{"variant":"secondary"}}):_vm._e(),_c('div',{ref:"stripe"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }